import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import Toggle from "react-toggle";
import classNames from "classnames";
import { UserContext } from "../../core/context";
import { seriesToMovingAverage, createSeries, createChartConf } from "../../core/charts";
import LytikoChart from "../../core/components/LytikoChart";
import WhiteBox from "../../core/components/WhiteBox";

const FoodChart = props => {
  /**
   * A data visualisation for a food.
   */

  const { food } = props;
  const user = useContext(UserContext);
  const [showTrendline, setShowTrendline] = useState(true);

  if (food.series.data.length < 1) {
    return (
      <WhiteBox className="lytiko-chart">
        <div className="notice">Need more data to display chart.</div>
      </WhiteBox>
    )
  }

  // Create series
  const series = createSeries(food.series, {
    fillGaps: true, totals: true, dayEnds: user.dayEnds
  });
  const options = createChartConf(user.timezone || moment.tz.guess());
  options.series = [series];

  // Enough dates for a trendline?
  const canShowTrendline = series.data.filter(d => d[1] > 0).length > (0.15 * series.data.length);
  if (canShowTrendline && showTrendline) {
    options.series.push(seriesToMovingAverage(series))
  }

  const className = classNames({
    "food-chart": true,
    "has-trendline": canShowTrendline && showTrendline,
  })
  
  return (
    <WhiteBox className={className}>
      <LytikoChart options={options} />
      {canShowTrendline && <div className="chart-controls">
        <div className="toggle-input">
          <Toggle
              id="trendline"
              checked={showTrendline}
              onChange={() => setShowTrendline(!showTrendline)}
          />
          <label htmlFor="trendline">Show Trendline</label>
        </div>
      </div>}
    </WhiteBox>
  )
}

FoodChart.propTypes = {
  food: PropTypes.object.isRequired,
}

export default FoodChart;